import axiosConfig from 'config/axiosConfig'
import UrlImage from 'config/UrlImage'
import userIcon from "assets/frontend/images/user.png";
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { Link, useHistory } from 'react-router-dom'
import "../../assets/frontend/style/pagination.css";

function ListArticle() {

    const [loading, setLoading] = useState(true)
    const [article, setArticle] = useState([])
    const history = useHistory()

    const [offset, setOffset] = useState(0)
    const [perPage] = useState(10)
    const [pageCount, setPageCount] = useState(0)

    const getData = async () => {
        const res = await axiosConfig.get(`/api/articles`)
        const article = res.data.article;
        const slice = article.slice(offset, offset + perPage)
            
        const showArticlelist = slice.map(item =>

            <div className="col-md-12 col-md-4 col-lg-3">
                <div className="card mt-2 mb-2" key={item.id}>
                    <div className="card-body">
                        <Link to={`/article/read/${item.slug}`} className="component-content d-block">
                            <div className="content-thumbnail">
                                <div className="content-image">
                                    <Link to={`/article/read/${item.slug}`}>
                                        <img src={`${UrlImage}/${item.image}`} className="img-fluid" />
                                    </Link>
                                </div>
                            </div>
                            <div className="content-title">
                                {item.name}
                            </div>
                        </Link>
                        <div className="divider"></div>
                        <div className="author">
                            <div className="author-profile">
                                <img
                                    src={userIcon}
                                    className="profile-picture rounded-circle"
                                    alt=""
                                />
                                <p className="author-name">Author</p>
                                <div>
                                   Kategori disini
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        setArticle(showArticlelist)
        setPageCount(Math.ceil(article.length / perPage))
    }

    const handlePageClick = (e) => {
        const selectedPage = e.selectedPage
        setOffset(selectedPage + 1)
    }

    useEffect(() => {
        getData()
    }, [offset])
    return (
        <div className="row mb-5">
            {article}
            
            <div className="row">
                <div className="text-center mt-4">
                    <ReactPaginate
                        previousLabel={"sebelumnya"}
                        nextLabel={"selanjutnya"}
                        breakLabel={"...."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                    />
                </div>
            </div>
        </div>

    )
}

export default ListArticle
